
import { defineComponent, PropType } from "vue";
import { useAutoHeight } from "@/shared/composables/useAutoHeight";
import Button from "@/shared/ui/Button/Button.vue";
import { Skill, Stunt } from "@/types";
import rules from "@/shared/constants/rules";

interface Data {
	tmpStunt: Stunt;
	skills: Skill[];
}

export default defineComponent({
	name: "AddNewAndEditStunt",
	components: { Button },
	emits: ["close", "update", "remove"],
	props: {
		stunt: {
			type: Object as PropType<Stunt>,
			required: true,
		},
		mode: {
			type: String,
			default: "new",
		},
	},
	setup() {
		return useAutoHeight();
	},
	data(): Data {
		return {
			tmpStunt: JSON.parse(JSON.stringify(this.stunt)),
			skills: rules.SKILLS.map((e) => {
				return {
					...e,
					localizedName: this.$t(`skill__${e.name}`),
				};
			}).sort((a, b) => a.localizedName.localeCompare(b.localizedName)),
		};
	},
	computed: {
		isValid() {
			return (
				this.tmpStunt.name &&
				this.tmpStunt.description &&
				this.tmpStunt.skill
			);
		},
	},
	mounted() {
		this.autoUpdateHeight(this.$refs.textarea as HTMLTextAreaElement);
	},
	methods: {
		remove() {
			this.$emit("remove");
			this.$emit("close");
		},
		close() {
			this.$emit("close");
		},
		update() {
			this.$emit("update", this.tmpStunt);
			this.$emit("close");
		},
	},
});
